import React from "react";
import { Card, Radio, Text } from "@merge-api/merge-javascript-shared";
import type { ProductKey } from "@merge-api/merge-javascript-shared";
import { ExploreMergeOption } from "../types";

interface Props {
  option: ExploreMergeOption;
  onSelect: (product: ProductKey) => void;
}

const ProductOption = ({ option, onSelect }: Props) => {
  // render
  return (
    <Card className="cursor-pointer p-5" onClick={() => onSelect(option.product)}>
      <Radio
        value={option.product}
        label={
          <span className="flex flex-col gap-1">
            <Text as="span" variant="h6">
              {option.title}
            </Text>
            <Text as="span">{option.description}</Text>
          </span>
        }
      />
    </Card>
  );
};

export default ProductOption;
